<script lang="ts">
	import Icon from "../Icon.svelte";
	import translations from "../../templates/Contact.translations.json";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { getTranslate } from "../../utils/getTranslate.js";
	import { formatPhoneNumber } from "../../../../core/utils/formatPhoneNumber";

	export let icon: string;
	export let role: string;
	export let email: string | undefined = undefined;
	export let phone: string | undefined = undefined;

	const translate = getTranslate(translations);
</script>

<div class="border-lttertiary -mt-px flex w-full flex-col border-b border-l border-r border-t lg:border-r-0">
	<div class="bg-lttertiary-100/70 flex h-64 w-full items-start justify-start gap-2 p-8">
		<Icon {icon} class="text-ltprimary-300 h-20 w-[6.25rem]" />
	</div>

	<div>
		<div class="border-lttertiary border-b p-8">
			<h3 class="text-ltprimary text-2lg/none font-lexend mb-0 font-normal tracking-[0.02em]">
				{nbspify(role)}
			</h3>
		</div>

		{#if email}
			<div class="p-8">
				<p class="!my-0 block text-base/[1.6] font-normal uppercase tracking-[0.02em] text-black">
					{translate("email")}
				</p>
				<a href="mailto:{email}" class="text-ltprimary text-base font-medium tracking-[0.02em]">
					{nbspify(email)}
				</a>
			</div>
		{/if}

		{#if phone}
			<div class="border-lttertiary border-t p-8">
				<p class="!my-0 block text-base/[1.6] font-normal uppercase tracking-[0.02em] text-black">
					{translate("phone")}
				</p>
				<a href="tel:{phone}" class="text-ltprimary text-base font-medium tracking-[0.02em]">
					{formatPhoneNumber(phone)}
				</a>
			</div>
		{/if}
	</div>
</div>
